// import React from "react";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'


import partner01 from "../assets/Partners/abb.webp"
import partner02 from "../assets/Partners/Allen-Bradly-.webp"
import partner03 from "../assets/Partners/BITZER.webp"
import partner04 from "../assets/Partners/Carrier.webp"
import partner05 from "../assets/Partners/Danfoss.webp"
import partner06 from "../assets/Partners/Deepchill-.webp"
import partner07 from "../assets/Partners/Frick-Johnsons-controls-.webp"
import partner08 from "../assets/Partners/HB-Products.webp"
import partner09 from "../assets/Partners/Hermetic-.webp"
import partner10 from "../assets/Partners/Mycom.webp"
import partner11 from "../assets/Partners/Ocean-Blue.webp"
import partner12 from "../assets/Partners/Schneider.webp"
import partner13 from "../assets/Partners/Siemens.webp"

const partners = [
     {src:partner01},
     {src:partner02},
     {src:partner03},
     {src:partner04},
     {src:partner05},
     {src:partner06},
     {src:partner07},
     {src:partner08},
     {src:partner09},
     {src:partner10},
     {src:partner11},
     {src:partner12},
     {src:partner13}
]

function Team() {
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
                        {/* <!--Start breadcrumb area-->      */}
                <section className="breadcrumb-area">
                    <div className="container text-center">
                         <div className="sec-title">
            <h1 className="title-anim"><span>Meet Our Partners</span></h1>
        </div>
                    </div>
                </section>
                {/* <!--End breadcrumb area--> */}

                {/* <!--Start breadcrumb bottom area--> */}
                {/* <section className="breadcrumb-botton-area">
                    <div className="container">
                        <div className="left">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li className="active">Meet Our Team</li>
                            </ul>    
                        </div>
                    </div>
                </section> */}
                {/* <!--End breadcrumb bottom area--> */}

                {/* <!--Start team area--> */}
                <section className="team-area">
                    <div className="container">
                        <div className="row">
                             {partners.map((partner, id) => (
                            <div className="col-md-6 col-sm-6 col-xs-12" key={id}>
                                <div className="single-team-member">
                                    <div className="img-holder">
                                        <img src={partner.src} alt="Mycom.webp"/>
                                       
                                    </div>
                                    <div className="text-holder">
                                        <h3>Mycom</h3>
                                    </div>    
                                </div> 
                            </div>
                             ))}
                          
                        </div>
                    </div>
                </section>
                {/* <!--End team area--> */}

          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Team;


